import type { ArticleEntity } from "@similarweb/pro-education-bar";
import { ArticlesSet, AttachmentsContainer } from "@similarweb/pro-education-bar";
import Sentry from "@similarweb/sentry-logger";
import { getProPageHeaders } from "@similarweb/pro-logic-components";

export class ArticlesService {
    private static initUrl = "/api/educationbar/articles";
    private static searchUrl = "/api/educationbar/search";
    private static viewedUrl = "/api/educationbar/viewed";
    private static articleUrl = "/api/educationbar/article";
    private static attachmentsUrl = "/api/educationbar/attachments";
    private static searchKey = "terms";
    private static initKey = "label";
    private static idKey = "id";

    public static async GetArticleById(id: number): Promise<ArticleEntity> {
        const searchUrl = `${ArticlesService.articleUrl}?${ArticlesService.idKey}=${id}&locale=en-us`;
        try {
            const result = await fetch(searchUrl, {
                method: "GET",
                credentials: "include",
                ...getProPageHeaders(),
            });
            const error = ArticlesService.handleErrors(result);
            return await result.json();
        } catch (_err) {}
    }

    public static async GetArticlesByFilter(term: string, initQuery: boolean): Promise<ArticlesSet> {
        let searchUrl = null;

        if (initQuery) {
            searchUrl = `${ArticlesService.initUrl}?${ArticlesService.initKey}=${term.trim() || '""'}`;
        } else {
            searchUrl = `${ArticlesService.searchUrl}?${ArticlesService.searchKey}=${term.trim() || '""'}`;
        }
        try {
            const result = await fetch(searchUrl, {
                method: "GET",
                credentials: "include",
                ...getProPageHeaders(),
            });
            const error = ArticlesService.handleErrors(result);
            return await result.json();
        } catch (_err) {
            return new ArticlesSet([], "");
        }
    }

    public static async GetAttachments(articleId: number): Promise<AttachmentsContainer> {
        const queryUrl = `${ArticlesService.attachmentsUrl}?id=${articleId}`;

        try {
            const result = await fetch(queryUrl, {
                method: "GET",
                credentials: "include",
                ...getProPageHeaders(),
            });
            const error = ArticlesService.handleErrors(result);
            return await result.json();
        } catch (_err) {
            return new AttachmentsContainer([]);
        }
    }

    public static async OnArticleViewed(articleId: number): Promise<any> {
        const queryUrl = `${ArticlesService.viewedUrl}`;

        try {
            const result = await fetch(queryUrl, {
                method: "POST",
                credentials: "include",
                body: JSON.stringify(articleId),
                headers: {
                    "Content-Type": "application/json",
                    Accept: "application/json",
                    ...getProPageHeaders(),
                },
            });
            const error = ArticlesService.handleErrors(result);
        } catch (_err) {}
    }

    private static handleErrors(response) {
        if (!response.ok) {
            Sentry.error("error in handleErrors in ArticlesService.ts", new Error(response.statusText));
        }
        return response;
    }
}
